<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header -->
        <div class="row align-items-center" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle mb-0">Course Type</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-center">
            <p class="adminName mb-0 mr-2">{{ adminName }}</p>
            <img width="36px" height="36px" src="assets/tenant-avatar.jpg" class="rounded-circle" />
          </div>
        </div>

        <!-- Search + Add -->
        <div class="row my-4 align-items-center">
          <!-- Searchbar -->
          <div class="col-md-4">
            <div class="search-wrapper">
              <i class="fa fa-search search-icon"></i>
              <input
                type="text"
                class="search-input"
                placeholder="Course Type"
                [(ngModel)]="searchval"
                (input)="onChangeEvent($event)"
              />
              <button *ngIf="searchval" class="clear-btn" (click)="reset()">✕</button>
            </div>
          </div>

          <div class="col-md-4 ml-auto text-right">
            <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()">
              <i class="fa fa-plus" aria-hidden="true"></i> Add Course Type
            </button>
          </div>
        </div>

        <!-- Data list -->
        <div class="row" *ngIf="showData">
          <div class="col-md-4 degreeContent" *ngFor="let course of allCourseType">
            <p style="text-align: left;">
              <img width="30px" height="30px" class="rounded-circle imgTable" [src]="course.image" />
              {{ course.type }}
              <i class="fa fa-trash-o iconEdit" aria-hidden="true" (click)="deleteCourseType(course)"></i>
              <i class="fa fa-pencil iconEdit" (click)="editCourseType(course)" aria-hidden="true"></i>
            </p>
          </div>
        </div>

        <!-- No Data -->
        <div class="noData" *ngIf="showNodata">
          <h2>Currently No Data Available!</h2>
        </div>
      </div>

      <!-- Add/Edit Modal -->
      <div class="backdrop" [ngStyle]="{'display':display}"></div>
      <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <!-- Header with close X -->
            <div class="modal-header d-flex justify-content-between align-items-center" *ngIf="showAdd">
              <div>Add Course Type</div>
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-header d-flex justify-content-between align-items-center" *ngIf="showEdit">
              <div>Edit Course Type</div>
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="dltmodal-content animate modal-body dltBl">
              <form [formGroup]="courseTypeForm" (ngSubmit)="$event.preventDefault()">
                <label>Course Type</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="courseTypeVal"
                  [(ngModel)]="courseType"
                />
                <div class="error-messages">
                  <div *ngFor="let error of error_messages.courseTypeVal">
                    <div
                      class="error-message"
                      *ngIf="courseTypeForm.get('courseTypeVal').hasError(error.type) && (courseTypeForm.get('courseTypeVal').dirty || courseTypeForm.get('courseTypeVal').touched)"
                    >
                      {{ error.message }}
                    </div>
                  </div>
                </div>

                <label class="uploadImage" style="display:inline-block; margin-top:10px; cursor:pointer;">
                  Upload Image
                  <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                  <input
                    type="file"
                    formControlName="courseTypeImage"
                    (change)="handleFileInput($event.target.files)"
                    hidden
                  />
                </label>

                <div class="mt-2">
                  <img width="80px" height="80px" *ngIf="imageUrl" [src]="imageUrl" />
                </div>

                <div class="error-messages">
                  <div *ngFor="let error of error_messages.courseTypeImage">
                    <div
                      class="error-message"
                      *ngIf="courseTypeForm.get('courseTypeImage').hasError(error.type) && (courseTypeForm.get('courseTypeImage').dirty || courseTypeForm.get('courseTypeImage').touched)"
                    >
                      {{ error.message }}
                    </div>
                  </div>
                </div>

                <div class="addBtn" *ngIf="showAdd">
                  <button class="commonBtn mt-2" type="button" (click)="addCourseType()">
                    Add Course Type
                  </button>
                </div>
                <div class="addBtn" *ngIf="showEdit">
                  <button class="commonBtn mt-2" type="button" (click)="updateCourseType()">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Modal -->
      <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
      <div class="modal" id="deleteModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
              <p>Do you want to delete Course Type ?</p>
              <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
              <button
                type="submit"
                class="btn btn-danger"
                (click)="onCloseHandled()"
                style="width: 20%;margin-left: 0.3em;"
              >
                No
              </button>
              <br /><br />
              <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
